import { SignInPage } from '~/features/adv_account/SigninPage'
import { pagesPath } from '~/lib/$path'
import { authenticate } from '~/lib/authenticate'

export default authenticate(SignInPage, ({ currentUserAdv }) => ({
  redirects: [
    [pagesPath.signin.support.$url().pathname, currentUserAdv?.authority === 'support'],
    [pagesPath.home.$url().pathname, currentUserAdv !== null],
  ],
}))
